<script>
import ModalBus from '@/eventBus'

export default {
  name: 'SuccessQuoteFormVehicle',

  props: {
    url: String,
  },

  computed: {
    vehicleListUrl() {
      return this.url
    },
  },

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ $t('vehicles.quoteFormSuccess.title') }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <div class="flex w-full items-start rounded-xl border border-primary px-2 py-4">
        <svg
          class="mr-4 h-auto w-8"
          fill="none"
          height="33"
          viewBox="0 0 34 33"
          width="34"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32.1111 5.24338H30.0963L29.7185 1.91425C29.5926 0.832282 28.6691 0 27.5358 0H6.4642C5.33086 0 4.40741 0.832282 4.28148 1.91425L3.9037 5.24338H1.88889C0.839506 5.24338 0 6.07566 0 7.11601V11.9849C0 13.0252 0.839506 13.8575 1.88889 13.8575H2.43457V15.314C1.76296 15.4805 1.21728 16.1047 1.21728 16.8537V23.2207C1.21728 23.9697 1.72099 24.5939 2.43457 24.7604V31.4187C2.43457 32.2926 3.14815 33 4.02963 33H6.4642C7.34568 33 8.05926 32.2926 8.05926 31.4187V24.7604H8.85679L10.8296 27.9647C11.1235 28.4224 11.6272 28.7137 12.1728 28.7137H22.121C22.7086 28.7137 23.2543 28.3808 23.5062 27.8815L25.1852 24.7604H25.9407V31.377C25.9407 32.2509 26.6543 32.9584 27.5358 32.9584H29.9704C30.8519 32.9584 31.5654 32.2509 31.5654 31.377V24.5939C32.1111 24.3443 32.4889 23.8033 32.4889 23.1791V16.8121C32.4889 16.1879 32.1111 15.6469 31.5654 15.3972V13.8575H32.1111C33.1605 13.8575 34 13.0252 34 11.9849V7.11601C34 6.07566 33.1605 5.24338 32.1111 5.24338ZM31.1457 20.3909H2.56049V16.8121C2.56049 16.6873 2.68642 16.5624 2.81235 16.5624H6.17037C7.05185 16.5624 7.76543 15.855 7.76543 14.9811V12.6091H26.1926H26.2765V14.9811C26.2765 15.855 26.9901 16.5624 27.8716 16.5624H30.8938C31.0198 16.5624 31.1457 16.6873 31.1457 16.8121V20.3909ZM30.8938 23.4287H3.10617H2.81235C2.68642 23.4287 2.56049 23.3039 2.56049 23.1791V21.7226H31.1457V23.1791C31.1457 23.3039 31.0198 23.4287 30.8938 23.4287ZM25.8568 11.319H7.84938L5.37284 9.98739H28.5012L25.8568 11.319ZM27.8296 15.2308C27.7037 15.2308 27.5778 15.1059 27.5778 14.9811V11.9016L30.2222 10.6116V12.8588V15.2308H27.8296ZM5.62469 2.03909C5.66667 1.62295 6.04444 1.29004 6.4642 1.29004H27.5358C27.9556 1.29004 28.3333 1.62295 28.3753 2.03909L29.1309 8.65574H4.86914L5.62469 2.03909ZM1.34321 11.9849V7.11601C1.34321 6.82472 1.59506 6.57503 1.88889 6.57503H3.7358L3.44198 9.23834C2.85432 9.36318 2.43457 9.86255 2.43457 10.4868V12.5259H1.88889C1.59506 12.5259 1.34321 12.2762 1.34321 11.9849ZM3.77778 13.8575V10.6532L6.42222 12.0681V15.0227C6.42222 15.1475 6.2963 15.2724 6.17037 15.2724H3.77778V13.8575ZM6.71605 31.3354C6.71605 31.4603 6.59012 31.5851 6.4642 31.5851H4.02963C3.9037 31.5851 3.77778 31.4603 3.77778 31.3354V24.7604H6.71605V31.3354ZM22.3309 27.2156C22.2889 27.2989 22.2049 27.3405 22.121 27.3405H12.1728C12.0889 27.3405 12.0049 27.2989 11.963 27.2156L10.4099 24.7188H23.6741L22.3309 27.2156ZM29.9704 31.5851H27.5358C27.4099 31.5851 27.284 31.4603 27.284 31.3354V24.7604H30.2222V31.377C30.2222 31.4603 30.0963 31.5851 29.9704 31.5851ZM32.6568 11.9849C32.6568 12.2762 32.4049 12.5259 32.1111 12.5259H31.5654V10.4868C31.5654 9.86255 31.1457 9.36318 30.558 9.23834L30.2642 6.57503H32.1111C32.4049 6.57503 32.6568 6.82472 32.6568 7.11601V11.9849Z"
            fill="#469752" />
          <path
            d="M23.59 13.4414H10.4518C9.57027 13.4414 8.85669 14.1488 8.85669 15.0227V17.7277C8.85669 18.6016 9.57027 19.309 10.4518 19.309H23.59C24.4715 19.309 25.1851 18.6016 25.1851 17.7277V15.0227C25.1431 14.1488 24.4295 13.4414 23.59 13.4414ZM17.5036 14.7731H20.148V17.9773H17.5036V14.7731ZM16.1604 17.9773H13.8518V14.7731H16.2024L16.1604 17.9773ZM10.1999 17.7277V15.0227C10.1999 14.8979 10.3258 14.7731 10.4518 14.7731H12.5085V17.9773H10.4518C10.3258 17.9773 10.1999 17.8525 10.1999 17.7277ZM23.7999 17.7277C23.7999 17.8525 23.674 17.9773 23.548 17.9773H21.4493V14.7731H23.548C23.674 14.7731 23.7999 14.8979 23.7999 15.0227V17.7277Z"
            fill="#469752" />
          <path
            d="M7.09383 17.6444H4.02964C3.65186 17.6444 3.35803 17.9357 3.35803 18.3102C3.35803 18.6848 3.65186 18.9761 4.02964 18.9761H7.09383C7.47161 18.9761 7.76544 18.6848 7.76544 18.3102C7.76544 17.9357 7.47161 17.6444 7.09383 17.6444Z"
            fill="#469752" />
          <path
            d="M29.9704 17.6444H26.9062C26.5284 17.6444 26.2346 17.9357 26.2346 18.3102C26.2346 18.6848 26.5284 18.9761 26.9062 18.9761H29.9704C30.3482 18.9761 30.642 18.6848 30.642 18.3102C30.642 17.9357 30.3482 17.6444 29.9704 17.6444Z"
            fill="#469752" />
        </svg>
        <p class="font-sans text-sm font-bold text-primary">
          {{ $t('vehicles.quoteFormSuccess.description') }}
        </p>
      </div>
      <div class="mt-8 flex w-full flex-col">
        <a
          class="btn mb-4 w-full"
          href="/"
          >{{ $t('buttons.backToIndex') }}</a
        >
        <a
          :href="vehicleListUrl"
          class="btn w-full border border-secondary bg-white text-secondary">
          {{ $t('vehicles.quoteFormSuccess.vehicles_list') }}
        </a>
      </div>
    </div>
  </div>
</template>
